export default ["en","tr"];